















import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { VideoPostCSS } from "@/services/posts/postTypes/video";

    @Component
export default class VideoStyle extends Vue {
        @Prop() private itemStyle!: Style;

        // lifecycle hooks
        public created(): void {
        }

        // computed
        get model(): VideoPostCSS {
            return this.itemStyle.css
                ? (this.itemStyle.css as VideoPostCSS)
                : ({} as VideoPostCSS);
        }
}
